<template>
  
<div v-if="imagens && imagens.length > 0">
  <c-q-separator class="q-pt-lg q-pb-md" />

  <div class="row q-pb-xs">
    <span class="midia-app-label-sm">Imagens Configuradas</span>
  </div>

  <div class="row q-gutter-lg q-py-md">
    <div 
      v-for="imagem in imagens" 
      :key="imagem.posicaoImagem"
      class="column items-center"
    >
      <div class="text-caption q-mb-sm">
        {{ getNomePosicaoImagem(imagem.posicaoImagem) }}
      </div>

        <img
          :src="imagem.urlS3 ? imagem.urlS3 : imagem.urlPreview"
          style="width: 120px; height: 120px; object-fit: cover; border-radius: 4px; border: 1px solid #e0e0e0;"
          :alt="`Imagem posição ${imagem.posicaoImagem}`"
        />
        <!-- <div class="text-caption q-mt-sm">Duração: {{ imagem.duracaoImagem }}s</div> -->
         <div class="text-caption q-mt-sm" v-if="[1, 2, 3, 4].includes(imagem.posicaoImagem)">
  Duração: {{ imagem.duracaoImagem }}s
</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { computed } from 'vue'

const institutionalStore = useInstitutionalStore()

/*const imagens = computed(() => {
  return institutionalStore.institutionalDetail?.imagens?.length
    ? institutionalStore.institutionalDetail.imagens
    : institutionalStore.imagensDraft
})*/

const imagens = computed(() => institutionalStore.imagensDraft)

const getNomePosicaoImagem = (posicao: number) => {
  const mapa: Record<number, string> = {
    1: 'Tela Inicial 1',
    2: 'Tela Inicial 2',
    3: 'Tela Inicial 3',
    4: 'Tela Inicial 4',
    5: 'Tela de Abertura',
    6: 'Tela de Aguarde e Leitura do Cartão (Geral)',
    7: 'Tela de Aguarde e Leitura do Cartão (Apenas Cartões com Chip)',
    8: 'Botão ATM - Sacar sem cartão',
    9: 'Botão ATM - Recarga celular',
    10: 'Botão ATM - Mais serviços',
    11: 'Botão ATM - Depositar dinheiro'
  }

  return mapa[posicao] || `Posição ${posicao}`
}

</script>

<style scoped>
</style>
